import React from 'react'
// ##
import CategoriesTable from '../../modules/Category/components/CategoriesTable'

export default function SectionPage() {
  return <CategoriesTable />
}
